<template>
  <div>
    <the-nav-bar :title="$t('notice.smartTradingEdit')" class="nav-bar" />
    <div class="body-wrapper" v-if="isLoaded">
      <md-scroll-view ref="scrollView" :scrolling-x="false" auto-reflow>
        <div class="scroll-wrapper" :class="{ isEdit }">
          <div class="field">
            <div
              class="field-item row-justify-center"
              v-for="key of fieldItemList"
              :key="key"
              @click="showOptions(key)"
            >
              <div class="field-item-title">{{ $t(`notice.${key}`) }}</div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText(`${key}Text`) }"
              >
                {{ getText(`${key}Text`) || $t('notice.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="tips row" v-if="isEdit">{{ $t('notice.tips') }}</div>
        <div class="pb-30"></div>
      </md-scroll-view>
      <div class="bottom">
        <div class="button-wrapper row">
          <md-button
            class="save"
            round
            :type="isPostBtnDisabled ? 'disabled' : 'primary'"
            @click="save"
          >
            {{ $t('common.save') }}
          </md-button>
        </div>
        <div class="help">
          <p>
            {{ $t('orderDetail.assistance') }}
          </p>
        </div>
      </div>
    </div>
    <md-popup v-model="isShowPopup" position="bottom" class="popup">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupData.title"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="popup-body">
        <div
          class="popup-item row-center"
          v-for="(item, index) in popupData.list"
          :key="`popup-item-${popupData.name}-${index}`"
          @click="onChoose(item)"
          :class="{ active: item.value === popupData.value }"
        >
          <div class="text">{{ item.text }}</div>
        </div>
      </md-scroll-view>
    </md-popup>
  </div>
</template>

<script>
import {
  ScrollView,
  Button,
  Switch,
  Toast,
  Icon,
  Popup,
  PopupTitleBar,
  Dialog,
} from 'mand-mobile';
import { mapState } from 'vuex';
import postAdNotice from '@/api/post-ad-notice';
import putAdNotice from '@/api/put-ad-notice';
import TheNavBar from '@/components/the-nav-bar';
export default {
  components: {
    TheNavBar,
    [ScrollView.name]: ScrollView,
    [Button.name]: Button,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      isLoaded: true,
      isActive: false,
      isShowPopup: false,
      popupData: {
        name: '',
        value: '',
        title: '',
        list: [],
      },
      title: '',
      isEdit: false,
    };
  },
  computed: {
    ...mapState({
      settings: state => state.settings,
      noticeTemp: state => state.noticeTemp,
      noticeStore: state => state.noticeStore,
    }),
    fieldItemList() {
      if (
        (this.isEdit && this.noticeStore.alertCount === 1) ||
        (!this.isEdit && this.noticeTemp.alertCount === 1)
      ) {
        return [
          'type',
          'crypto',
          'fiatCurrency',
          'minPercentage',
          'maxPercentage',
          'alertCount',
        ];
      } else {
        return [
          'type',
          'crypto',
          'fiatCurrency',
          'minPercentage',
          'maxPercentage',
          'alertCount',
          'alertGap',
        ];
      }
    },
    typeList() {
      return [
        {
          value: 'buy',
          text: this.$t('notice.buy'),
        },
        {
          value: 'sell',
          text: this.$t('notice.sell'),
        },
      ];
    },
    typeText() {
      const { type } = this.isEdit ? this.noticeStore : this.noticeTemp;
      return (type && this.$t(`notice.${type}`)) || '';
    },
    cryptoList() {
      return this.settings.cryptoList.map(item => {
        return {
          value: item.id,
          text: `${item.name} (${item.symbol})`,
        };
      });
    },
    cryptoText() {
      const { crypto } = this.isEdit ? this.noticeStore : this.noticeTemp;
      const obj = this.cryptoList.find(item => {
        return item.value == crypto;
      });
      return (obj && obj.text) || '';
    },
    fiatCurrencyList() {
      return this.settings.legalCurrencyList.map(item => {
        return {
          value: item.id,
          text: `${item.unit} (${item.unit})`,
        };
      });
    },
    fiatCurrencyText() {
      const { fiatCurrency } = this.isEdit ? this.noticeStore : this.noticeTemp;
      const obj = this.fiatCurrencyList.find(item => {
        return item.value == fiatCurrency;
      });
      return (obj && obj.text) || '';
    },
    alertCountList() {
      const list = [];
      for (let i = 1; i < 4; i++) {
        list.push({ value: i, text: `${i}${this.$t('notice.times')}` });
      }
      return list;
    },
    alertCountText() {
      const { alertCount } = this.isEdit ? this.noticeStore : this.noticeTemp;
      return (alertCount && `${alertCount}${this.$t('notice.times')}`) || '';
    },
    alertGapList() {
      const list = [];
      for (let i = 1; i < 9; i++) {
        list.push({ value: i, text: `${i}H` });
      }
      return list;
    },
    alertGapText() {
      const { alertGap } = this.isEdit ? this.noticeStore : this.noticeTemp;
      return (alertGap && `${alertGap}H`) || '';
    },
    minPercentageText() {
      const { minPercentage, reference, minGap } = this.isEdit
        ? this.noticeStore
        : this.noticeTemp;
      const { referenceList } = this.settings;
      const obj = referenceList.find(item => item.id === reference);
      if (obj) {
        if (obj.value === 'exinone') {
          const noticeType =
            Number(minGap) < 0 ? 'notice.below' : 'notice.above';
          return minGap
            ? `${this.$t(noticeType)} ${this.$t(
              'customize.exinone',
            )} ${Math.abs(Number(minGap))} CNY`
            : '';
        } else {
          const noticeType =
            Number(minPercentage) < 0 ? 'notice.below' : 'notice.above';
          return minPercentage
            ? `${this.$t(noticeType)} ${obj && obj.text} ${Math.abs(
              parseFloat(minPercentage),
            )}%`
            : '';
        }
      } else {
        return '';
      }
    },
    maxPercentageText() {
      const { maxPercentage, reference, maxGap } = this.isEdit
        ? this.noticeStore
        : this.noticeTemp;
      const { referenceList } = this.settings;
      const obj = referenceList.find(item => item.id === reference);
      if (obj) {
        if (obj.value === 'exinone') {
          const noticeType =
            Number(maxGap) < 0 ? 'notice.below' : 'notice.above';
          return maxGap
            ? `${this.$t(noticeType)} ${this.$t(
              'customize.exinone',
            )} ${Math.abs(Number(maxGap))} CNY`
            : '';
        } else {
          const noticeType =
            Number(maxPercentage) < 0 ? 'notice.below' : 'notice.above';
          return maxPercentage
            ? `${this.$t(noticeType)} ${obj && obj.text} ${Math.abs(
              parseFloat(maxPercentage),
            )}%`
            : '';
        }
      } else {
        return '';
      }
    },
    isPostBtnDisabled() {
      let disabled = false;
      this.fieldItemList.forEach(key => {
        disabled = disabled || !this[`${key}Text`];
      });
      return disabled || this.isSubmitting;
    },
  },
  mounted() {
    let promise = Promise.resolve();
    if (!this.settings.isSettingsLoaded) {
      Toast.loading(this.$t('common.loading'));
      promise = this.$store.dispatch('updateSettings');
    }
    promise
      .then(() => {
        Toast.hide();
        this.title = this.noticeTemp.title;
        // this.provisions = this.noticeTemp.provisions;
      })
      .catch(err => {
        Toast.hide();
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
    if (this.$route.query.id) {
      this.isEdit = true;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/mine/notice') {
      this.$store.commit('setNoticeStore', { isNew: true });
    }
    next();
  },
  methods: {
    getText(key) {
      return this[key];
    },
    save() {
      const max = Number(
        this.isEdit
          ? this.noticeStore.maxPercentage
          : this.noticeTemp.maxPercentage,
      );
      const min = Number(
        this.isEdit
          ? this.noticeStore.minPercentage
          : this.noticeTemp.minPercentage,
      );
      if (min > max) {
        Toast.failed(this.$t('notice.priceError'));
        return;
      }
      this.isSubmitting = true;
      Toast.loading(this.$t('common.loading'));
      const {
        type,
        crypto: asset_id,
        fiatCurrency: legal_currency_id,
        maxPercentage: max_percentage,
        minPercentage: min_percentage,
        alertCount: alert_count,
        alertGap: alert_gap,
        minGap: min_price_gap,
        maxGap: max_price_gap,
        reference,
      } = this.isEdit ? this.noticeStore : this.noticeTemp;
      let params = {
        type,
        asset_id,
        legal_currency_id,
        alert_count,
        alert_gap,
      };
      if (params.alert_count === 1) {
        params.alert_gap = 8;
      }
      if (reference == 0) {
        params.curr_type = 'avg';
        params.max_percentage = max_percentage;
        params.min_percentage = min_percentage;
      } else if (reference == 1) {
        params.curr_type = 'exinone';
        params.max_percentage = max_price_gap;
        params.min_percentage = min_price_gap;
      }
      if (this.isEdit) {
        putAdNotice(this.noticeStore.id, params)
          .then(() => {
            Toast.hide();
            Toast.succeed(this.$t('notice.saveSuccess'));
            this.$nextTick(() => {
              this.isSubmitting = false;
              this.$router.back();
            });
          })
          .catch(err => {
            this.isSubmitting = false;
            Toast.hide();
            Dialog.failed({
              title: this.$t('error.occur'),
              content: err.message,
              cancelText: this.$t('common.cancel'),
              confirmText: this.$t('common.confirm'),
            });
          });
      } else {
        postAdNotice(params)
          .then(() => {
            Toast.hide();
            Toast.succeed(this.$t('notice.createSuccess'));
            this.$nextTick(() => {
              this.$store.commit('setNoticeTemp', { isNew: true });
              this.isSubmitting = false;
              this.$router.back();
            });
          })
          .catch(err => {
            this.isSubmitting = false;
            Toast.hide();
            Dialog.failed({
              title: this.$t('error.occur'),
              content: err.message,
              cancelText: this.$t('common.cancel'),
              confirmText: this.$t('common.confirm'),
            });
          });
      }
    },
    showOptions(key) {
      switch (key) {
        case 'type':
        case 'fiatCurrency':
        case 'crypto':
        case 'alertCount':
        case 'alertGap':
          this.showPopup(key);
          break;
        case 'minPercentage':
        case 'maxPercentage':
          if (!this.cryptoText || !this.fiatCurrencyText) {
            return Toast.info(this.$t('notice.setPriceAlert'));
          }
          this.$router.push({
            path: '/mine/notice/setPrice',
            query: {
              fiatCurrencyId: this.isEdit
                ? this.noticeStore.fiatCurrency
                : this.noticeTemp.fiatCurrency,
              cryptoId: this.isEdit
                ? this.noticeStore.crypto
                : this.noticeTemp.crypto,
              isAboveQuery: key === 'minPercentage' ? 0 : 1,
              isEdit: this.isEdit,
            },
          });
          break;
      }
    },
    showPopup(key) {
      let { name, title, list, value } = {};
      name = key;
      title = this.$t(`notice.${key}`);
      list = this[`${key}List`];
      value = this.isEdit ? this.noticeStore[key] : this.noticeTemp[key];
      this.popupData = {
        name,
        title,
        list,
        value,
      };
      this.$nextTick(() => {
        this.isShowPopup = true;
      });
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    onChoose(item) {
      const { value } = item;
      const { name } = this.popupData;
      this.popupData.value = value;
      const obj = {};
      obj[name] = value;
      this.$store.commit(this.isEdit ? 'setNoticeStore' : 'setNoticeTemp', obj);
      this.$nextTick(this.hidePopup);
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  position: absolute;
  absolute-pos(11.73vw);
  background: #fff;

  .scroll-wrapper {
    width: 100%;
    padding-bottom: 30vw;

    &.isEdit {
      padding-bottom: 0vw;
    }

    .field {
      .field-item {
        padding: 0 4.8vw;
        height: 17.07vw;
        font-size: 3.73vw;

        &:nth-child(even) {
          background: #F8FBFC;
        }

        .field-item-title {
          flex: 0 0 32vw;
          font-weight: bold;
        }

        .field-item-content {
          flex: 1 0 0%;
          text-align: right;
          color: #1b6fdc;

          &.inactive {
            color: #bcc7cb;
          }
        }
      }
    }
  }

  .bottom {
    background: #FFF;
    width: 100%;
    padding-top: 2.13vw;
    position: fixed;
    bottom: 0vw;
    z-index: 101;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    box-shadow: 0vw -1.07vw 2.13vw 0vw rgba(58, 86, 131, 0.07);

    .button-wrapper {
      justify-content: center;

      .save {
        width: 42.67vw;
        height: 9.6vw;
      }
    }

    .help {
      p {
        font-size: 3.2vw;
        color: #84969C;
        text-align: center;
        margin: 2.13vw 4.8vw 4.13vw;

        span {
          color: #1b6fdc;
        }
      }
    }
  }

  .tips {
    color: #dc521b;
    height: 17.07vw;
    font-size: 3.73vw;
    background: #FCF6F5;
    justify-content: center;
    align-items: center;
  }

  .pb-30 {
    padding-bottom: 30vw;
  }
}

.popup {
  .title-bar {
    border-bottom: 0.27vw solid #eaf1f3;

    >>> .title-bar-left, >>> .title-bar-right {
      width: 30%;
    }
  }

  .popup-body {
    padding-bottom: 10vw;
    height: auto;
    min-height: 60vw;
    max-height: 80vw;
    overflow-y: auto;
    background: #fff;
  }

  .popup-item {
    height: 12.8vw;
    margin: 0 6.4vw;
    font-size: 4.27vw;

    &.active {
      color: color-primary;
    }
  }
}
</style>
